// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AccountStandingData, AccountStandingErrors, AccountStandingResponses, AddMemberData, AddMemberErrors, AddMemberResponses, AddRosterEntryData, AddRosterEntryErrors, AddRosterEntryResponses, AnswerChallengeData, AnswerChallengeErrors, AnswerChallengeResponses, AnswerTwoFactorOfferData, AnswerTwoFactorOfferErrors, AnswerTwoFactorOfferResponses, ApplyData, ApplyErrors, ApplyInboundReconcileData, ApplyInboundReconcileErrors, ApplyInboundReconcileResponses, ApplyResponses, ApproveEventData, ApproveEventErrors, ApproveEventResponses, ArchiveCommitteeData, ArchiveCommitteeErrors, ArchiveCommitteeResponses, ArchiveGameData, ArchiveGameErrors, ArchiveGameResponses, AssociationStatisticsData, AssociationStatisticsErrors, AssociationStatisticsResponses, AuthenticateData, AuthenticateErrors, AuthenticateResponses, BoardCreateMembershipData, BoardCreateMembershipErrors, BoardCreateMembershipResponses, BoardData, BoardErrors, BoardResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ClearGameAccountData, ClearGameAccountErrors, ClearGameAccountResponses, ConfirmEmailChangeData, ConfirmEmailChangeErrors, ConfirmEmailChangeResponses, ConfirmTwoFactorData, ConfirmTwoFactorErrors, ConfirmTwoFactorResponses, CorrectEmailData, CorrectEmailErrors, CorrectEmailResponses, CreateAddressData, CreateAddressErrors, CreateAddressResponses, CreateBlogData, CreateBlogErrors, CreateBlogResponses, CreateBoardData, CreateBoardErrors, CreateBoardResponses, CreateCasualGameData, CreateCasualGameErrors, CreateCasualGameResponses, CreateCommitteeData, CreateCommitteeErrors, CreateCommitteeResponses, CreateContributionData, CreateContributionErrors, CreateContributionPeriodData, CreateContributionPeriodErrors, CreateContributionPeriodResponses, CreateContributionResponses, CreateEventData, CreateEventErrors, CreateEventResponses, CreateEventSignupData, CreateEventSignupErrors, CreateEventSignupResponses, CreateMemberProfileData, CreateMemberProfileErrors, CreateMemberProfileResponses, CreateMembershipData, CreateMembershipErrors, CreateMembershipResponses, CreateSeasonData, CreateSeasonErrors, CreateSeasonResponses, CreateSponsorData, CreateSponsorErrors, CreateSponsorResponses, CreateTargetData, CreateTargetErrors, CreateTargetResponses, CreateTeamData, CreateTeamErrors, CreateTeamResponses, CreateTelemetryData, CreateTelemetryErrors, CreateTelemetryResponses, CreateUserData, CreateUserErrors, CreateUserResponses, CsrfData, CsrfErrors, CsrfResponses, DeleteAddressByIdData, DeleteAddressByIdErrors, DeleteAddressByIdResponses, DeleteBoardData, DeleteBoardErrors, DeleteBoardResponses, DeleteByIdData, DeleteByIdErrors, DeleteByIdResponses, DeleteCommitteeByIdData, DeleteCommitteeByIdErrors, DeleteCommitteeByIdResponses, DeleteContributionData, DeleteContributionErrors, DeleteContributionPeriodByIdData, DeleteContributionPeriodByIdErrors, DeleteContributionPeriodByIdResponses, DeleteContributionResponses, DeleteEventByIdData, DeleteEventByIdErrors, DeleteEventByIdResponses, DeleteEventSignupData, DeleteEventSignupErrors, DeleteEventSignupResponses, DeleteMembershipData, DeleteMembershipErrors, DeleteMembershipResponses, DeleteSeasonData, DeleteSeasonErrors, DeleteSeasonResponses, DeleteSponsorByIdData, DeleteSponsorByIdErrors, DeleteSponsorByIdResponses, DeleteTeamData, DeleteTeamErrors, DeleteTeamResponses, DeleteUserByIdData, DeleteUserByIdErrors, DeleteUserByIdResponses, DownloadEventBannerData, DownloadEventBannerErrors, DownloadEventBannerResponses, DownloadPublicFileData, DownloadPublicFileErrors, DownloadPublicFileResponses, EmailAddressData, EmailAddressErrors, EmailAddressResponses, EndMembershipData, EndMembershipErrors, EndMembershipResponses, EndMembershipsData, EndMembershipsErrors, EndMembershipsResponses, EndSignInData, EndSignInErrors, EndSignInResponses, EnqueueData, EnqueueErrors, EnqueueResponses, EnterGameData, EnterGameErrors, EnterGameResponses, FieldTeamData, FieldTeamErrors, FieldTeamResponses, FindAddressByIdData, FindAddressByIdErrors, FindAddressByIdResponses, FindAllAddressesData, FindAllAddressesErrors, FindAllAddressesResponses, FindAllBoardsData, FindAllBoardsErrors, FindAllBoardsResponses, FindBankAccountData, FindBankAccountErrors, FindBankAccountResponses, FindBlogByIdData, FindBlogByIdErrors, FindBlogByIdResponses, FindBlogsData, FindBlogsErrors, FindBlogsResponses, FindBoardByIdData, FindBoardByIdErrors, FindBoardByIdResponses, FindCasualGamesData, FindCasualGamesErrors, FindCasualGamesResponses, FindCohortByIdData, FindCohortByIdErrors, FindCohortByIdResponses, FindCohortsData, FindCohortsErrors, FindCohortsResponses, FindCohortSubjectByIdData, FindCohortSubjectByIdErrors, FindCohortSubjectByIdResponses, FindCohortSubjectsData, FindCohortSubjectsErrors, FindCohortSubjectsResponses, FindCommitteeByIdData, FindCommitteeByIdErrors, FindCommitteeByIdResponses, FindCommitteeDeletionData, FindCommitteeDeletionErrors, FindCommitteeDeletionResponses, FindCommitteePageData, FindCommitteePageErrors, FindCommitteePageResponses, FindCommitteesByUserIdData, FindCommitteesByUserIdErrors, FindCommitteesByUserIdResponses, FindCommitteesData, FindCommitteesErrors, FindCommitteesResponses, FindContributionPeriodsData, FindContributionPeriodsErrors, FindContributionPeriodsResponses, FindContributionRemindersData, FindContributionRemindersErrors, FindContributionRemindersResponses, FindContributionsByPeriodIdData, FindContributionsByPeriodIdErrors, FindContributionsByPeriodIdResponses, FindContributionsData, FindContributionsErrors, FindContributionsResponses, FindCurrentContributionPeriodData, FindCurrentContributionPeriodErrors, FindCurrentContributionPeriodResponses, FindDeletedMembershipsData, FindDeletedMembershipsErrors, FindDeletedMembershipsResponses, FindDeletedUsersData, FindDeletedUsersErrors, FindDeletedUsersResponses, FindEventByIdData, FindEventByIdErrors, FindEventByIdResponses, FindEventRosterData, FindEventRosterErrors, FindEventRosterResponses, FindEventsData, FindEventsErrors, FindEventSignUpsByAccessTokenData, FindEventSignUpsByAccessTokenErrors, FindEventSignUpsByAccessTokenResponses, FindEventSignUpsByEventIdData, FindEventSignUpsByEventIdErrors, FindEventSignUpsByEventIdResponses, FindEventSignUpsData, FindEventSignUpsErrors, FindEventSignUpsResponses, FindEventsResponses, FindGameAccountsData, FindGameAccountsErrors, FindGameAccountsResponses, FindGameData, FindGameErrors, FindGameHoldingsData, FindGameHoldingsErrors, FindGameHoldingsResponses, FindGameResponses, FindMemberProfileByUserIdData, FindMemberProfileByUserIdErrors, FindMemberProfileByUserIdResponses, FindMembershipByIdData, FindMembershipByIdErrors, FindMembershipByIdResponses, FindMembershipsData, FindMembershipsErrors, FindMembershipsResponses, FindOwnContributionsData, FindOwnContributionsErrors, FindOwnContributionsResponses, FindOwnFirstContributionData, FindOwnFirstContributionErrors, FindOwnFirstContributionResponses, FindPlayedRostersData, FindPlayedRostersErrors, FindPlayedRostersResponses, FindRosterData, FindRosterErrors, FindRosterResponses, FindSeasonContentsData, FindSeasonContentsErrors, FindSeasonContentsResponses, FindSeasonGamesData, FindSeasonGamesErrors, FindSeasonGamesResponses, FindSeasonsData, FindSeasonsErrors, FindSeasonsResponses, FindSponsorByIdData, FindSponsorByIdErrors, FindSponsorByIdResponses, FindSponsorsData, FindSponsorsErrors, FindSponsorsResponses, FindTeamsData, FindTeamSeasonsData, FindTeamSeasonsErrors, FindTeamSeasonsResponses, FindTeamsErrors, FindTeamsResponses, FindTelemetryByIdData, FindTelemetryByIdErrors, FindTelemetryByIdResponses, FindUserByIdData, FindUserByIdErrors, FindUserByIdResponses, FindUserRoleChangesData, FindUserRoleChangesErrors, FindUserRoleChangesResponses, FindUserRolesData, FindUserRolesErrors, FindUserRolesResponses, FindUsersData, FindUsersErrors, FindUsersResponses, ForgetTrustedBrowserData, ForgetTrustedBrowserErrors, ForgetTrustedBrowserResponses, ForgetTrustedBrowsersData, ForgetTrustedBrowsersErrors, ForgetTrustedBrowsersResponses, ForwardAuthData, ForwardAuthErrors, ForwardAuthResponses, GetStats1Data, GetStats1Errors, GetStats1Responses, GetStatsData, GetStatsErrors, GetStatsResponses, HealthCheckData, HealthCheckErrors, HealthCheckResponses, JobTypesData, JobTypesErrors, JobTypesResponses, LeaveGameData, LeaveGameErrors, LeaveGameResponses, LinkExistingTargetData, LinkExistingTargetErrors, LinkExistingTargetResponses, LinkMemberData, LinkMemberErrors, LinkMemberResponses, LinkRosterEntryData, LinkRosterEntryErrors, LinkRosterEntryResponses, LinkUserData, LinkUserErrors, LinkUserResponses, List1Data, List1Errors, List1Responses, ListCohortTargetFoldersData, ListCohortTargetFoldersErrors, ListCohortTargetFoldersResponses, ListCohortTargetSystemsData, ListCohortTargetSystemsErrors, ListCohortTargetSystemsResponses, ListData, ListDiscordChannelsData, ListDiscordChannelsErrors, ListDiscordChannelsResponses, ListDiscordEmojisData, ListDiscordEmojisErrors, ListDiscordEmojisResponses, ListDiscordRolesData, ListDiscordRolesErrors, ListDiscordRolesResponses, ListErrors, ListGameChannelsData, ListGameChannelsErrors, ListGameChannelsResponses, ListResponses, ListUnclaimedDiscordMembersData, ListUnclaimedDiscordMembersErrors, ListUnclaimedDiscordMembersResponses, LockData, LockErrors, LockResponses, LogoutData, LogoutErrors, LogoutResponses, MarkPaidData, MarkPaidErrors, MarkPaidResponses, MarkUnpaidData, MarkUnpaidErrors, MarkUnpaidResponses, MemberActivateData, MemberActivateErrors, MemberActivateResponses, MoveCohortTargetData, MoveCohortTargetErrors, MoveCohortTargetResponses, MoveCohortTargetsData, MoveCohortTargetsErrors, MoveCohortTargetsResponses, MySecurityEventsData, MySecurityEventsErrors, MySecurityEventsResponses, MyServicesData, MyServicesErrors, MyServicesResponses, OpenDiscordChannelData, OpenDiscordChannelErrors, OpenDiscordInviteData, OpenDiscordInviteErrors, PendingActivationsData, PendingActivationsErrors, PendingActivationsResponses, PreviewBulkContributionEmailData, PreviewBulkContributionEmailErrors, PreviewBulkContributionEmailResponses, PreviewBulkEndData, PreviewBulkEndErrors, PreviewBulkEndResponses, PreviewBulkStartData, PreviewBulkStartErrors, PreviewBulkStartResponses, PreviewDescriptionData, PreviewDescriptionErrors, PreviewDescriptionResponses, PreviewInboundReconcileData, PreviewInboundReconcileErrors, PreviewInboundReconcileResponses, PreviewRecoveryEmailData, PreviewRecoveryEmailErrors, PreviewRecoveryEmailResponses, PreviewSentEmailData, PreviewSentEmailErrors, PreviewSentEmailResponses, PublishLineupData, PublishLineupErrors, PublishLineupResponses, ReadContributionEmailData, ReadContributionEmailErrors, ReadContributionEmailResponses, ReadDiscordLiveData, ReadDiscordLiveErrors, ReadDiscordLiveResponses, ReadDiscordMentionsData, ReadDiscordMentionsErrors, ReadDiscordMentionsResponses, ReadMyDiscordRoomsData, ReadMyDiscordRoomsErrors, ReadMyDiscordRoomsResponses, ReadStarboardData, ReadStarboardErrors, ReadStarboardResponses, ReenrolData, ReenrolErrors, ReenrolResponses, RegenerateBackupCodesData, RegenerateBackupCodesErrors, RegenerateBackupCodesResponses, RemoveGameData, RemoveGameErrors, RemoveGameResponses, RemoveMemberData, RemoveMemberErrors, RemoveMemberResponses, RemoveRosterEntryData, RemoveRosterEntryErrors, RemoveRosterEntryResponses, ReopenMembershipData, ReopenMembershipErrors, ReopenMembershipResponses, RepairMissingAddsData, RepairMissingAddsErrors, RepairMissingAddsResponses, RequestEmailChangeData, RequestEmailChangeErrors, RequestEmailChangeResponses, ResendRecoveryEmailData, ResendRecoveryEmailErrors, ResendRecoveryEmailResponses, ResendReenrolmentLinkData, ResendReenrolmentLinkErrors, ResendReenrolmentLinkResponses, ResendUserActivationData, ResendUserActivationErrors, ResendUserActivationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, ResetTwoFactorData, ResetTwoFactorErrors, ResetTwoFactorResponses, RestoreDeletedUserByIdData, RestoreDeletedUserByIdErrors, RestoreDeletedUserByIdResponses, RestoreMembershipData, RestoreMembershipErrors, RestoreMembershipResponses, ResumeSignupData, ResumeSignupErrors, ResumeSignupResponses, Retry1Data, Retry1Errors, Retry1Responses, RetryData, RetryErrors, RetryResponses, SaveAddressData, SaveAddressErrors, SaveAddressResponses, SearchCohortTargetsData, SearchCohortTargetsErrors, SearchCohortTargetsResponses, SearchDiscordMembersData, SearchDiscordMembersErrors, SearchDiscordMembersResponses, SecurityEventsData, SecurityEventsErrors, SecurityEventsResponses, SendContributionReminderBatchData, SendContributionReminderBatchErrors, SendContributionReminderBatchResponses, SendContributionReminderData, SendContributionReminderErrors, SendContributionReminderResponses, SendPaymentEmailsData, SendPaymentEmailsErrors, SendPaymentEmailsResponses, SetGameAccountData, SetGameAccountErrors, SetGameAccountResponses, SetGameOrganisersData, SetGameOrganisersErrors, SetGameOrganisersResponses, SetNameOnRostersData, SetNameOnRostersErrors, SetNameOnRostersResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, SetUpTwoFactorData, SetUpTwoFactorErrors, SetUpTwoFactorResponses, SetUserRolesData, SetUserRolesErrors, SetUserRolesResponses, SignInsData, SignInsErrors, SignInsResponses, SignOutElsewhereData, SignOutElsewhereErrors, SignOutElsewhereResponses, SignOutEverywhereData, SignOutEverywhereErrors, SignOutEverywhereResponses, SignUpData, SignUpErrors, SignUpResponses, StartMembershipsData, StartMembershipsErrors, StartMembershipsResponses, StepUpData, StepUpErrors, StepUpResponses, SwitchTargetData, SwitchTargetErrors, SwitchTargetResponses, TrustedBrowsersData, TrustedBrowsersErrors, TrustedBrowsersResponses, TurnOffTwoFactorData, TurnOffTwoFactorErrors, TurnOffTwoFactorResponses, TwoFactorSavedData, TwoFactorSavedErrors, TwoFactorSavedResponses, TwoFactorStandingData, TwoFactorStandingErrors, TwoFactorStandingResponses, UnfieldTeamData, UnfieldTeamErrors, UnfieldTeamResponses, UnlockData, UnlockErrors, UnlockResponses, UpdateAddressData, UpdateAddressErrors, UpdateAddressResponses, UpdateBlogData, UpdateBlogErrors, UpdateBlogResponses, UpdateBoardData, UpdateBoardErrors, UpdateBoardResponses, UpdateCasualGameData, UpdateCasualGameErrors, UpdateCasualGameResponses, UpdateCommitteeData, UpdateCommitteeErrors, UpdateCommitteePageData, UpdateCommitteePageErrors, UpdateCommitteePageResponses, UpdateCommitteeResponses, UpdateContributionPeriodData, UpdateContributionPeriodErrors, UpdateContributionPeriodResponses, UpdateDetailsData, UpdateDetailsErrors, UpdateDetailsResponses, UpdateEventData, UpdateEventErrors, UpdateEventResponses, UpdateEventSignUpByIdData, UpdateEventSignUpByIdErrors, UpdateEventSignUpByIdResponses, UpdateEventSignUpData, UpdateEventSignUpErrors, UpdateEventSignUpResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberProfileData, UpdateMemberProfileErrors, UpdateMemberProfileResponses, UpdateMemberResponses, UpdateMembershipData, UpdateMembershipErrors, UpdateMembershipResponses, UpdateRosterEntryData, UpdateRosterEntryErrors, UpdateRosterEntryResponses, UpdateSeasonData, UpdateSeasonErrors, UpdateSeasonResponses, UpdateSponsorData, UpdateSponsorErrors, UpdateSponsorResponses, UpdateTeamData, UpdateTeamErrors, UpdateTeamResponses, UpdateUserData, UpdateUserErrors, UpdateUserResponses, UploadCommitteeBannerData, UploadCommitteeBannerErrors, UploadCommitteeBannerResponses, UploadCommitteeIconData, UploadCommitteeIconErrors, UploadCommitteeIconResponses, UploadEventBannerData, UploadEventBannerErrors, UploadEventBannerResponses, UploadPublicImageData, UploadPublicImageErrors, UploadPublicImageResponses, UserActivateData, UserActivateErrors, UserActivateResponses, VersionData, VersionErrors, VersionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const findAllAddresses = <ThrowOnError extends boolean = false>(options?: Options<FindAllAddressesData, ThrowOnError>): RequestResult<FindAllAddressesResponses, FindAllAddressesErrors, ThrowOnError> => (options?.client ?? client).get<FindAllAddressesResponses, FindAllAddressesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/addresses',
    ...options
});

export const createAddress = <ThrowOnError extends boolean = false>(options: Options<CreateAddressData, ThrowOnError>): RequestResult<CreateAddressResponses, CreateAddressErrors, ThrowOnError> => (options.client ?? client).post<CreateAddressResponses, CreateAddressErrors, ThrowOnError>({
    responseType: 'json',
    url: '/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteAddressById = <ThrowOnError extends boolean = false>(options: Options<DeleteAddressByIdData, ThrowOnError>): RequestResult<DeleteAddressByIdResponses, DeleteAddressByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAddressByIdResponses, DeleteAddressByIdErrors, ThrowOnError>({ url: '/addresses/{id}', ...options });

export const findAddressById = <ThrowOnError extends boolean = false>(options: Options<FindAddressByIdData, ThrowOnError>): RequestResult<FindAddressByIdResponses, FindAddressByIdErrors, ThrowOnError> => (options.client ?? client).get<FindAddressByIdResponses, FindAddressByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/addresses/{id}',
    ...options
});

export const updateAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateAddressData, ThrowOnError>): RequestResult<UpdateAddressResponses, UpdateAddressErrors, ThrowOnError> => (options.client ?? client).put<UpdateAddressResponses, UpdateAddressErrors, ThrowOnError>({
    responseType: 'json',
    url: '/addresses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authenticate = <ThrowOnError extends boolean = false>(options: Options<AuthenticateData, ThrowOnError>): RequestResult<AuthenticateResponses, AuthenticateErrors, ThrowOnError> => (options.client ?? client).post<AuthenticateResponses, AuthenticateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({ url: '/auth/logout', ...options });

export const stepUp = <ThrowOnError extends boolean = false>(options: Options<StepUpData, ThrowOnError>): RequestResult<StepUpResponses, StepUpErrors, ThrowOnError> => (options.client ?? client).post<StepUpResponses, StepUpErrors, ThrowOnError>({
    url: '/auth/step-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const answerChallenge = <ThrowOnError extends boolean = false>(options: Options<AnswerChallengeData, ThrowOnError>): RequestResult<AnswerChallengeResponses, AnswerChallengeErrors, ThrowOnError> => (options.client ?? client).post<AnswerChallengeResponses, AnswerChallengeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findBlogs = <ThrowOnError extends boolean = false>(options?: Options<FindBlogsData, ThrowOnError>): RequestResult<FindBlogsResponses, FindBlogsErrors, ThrowOnError> => (options?.client ?? client).get<FindBlogsResponses, FindBlogsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/blogs',
    ...options
});

export const createBlog = <ThrowOnError extends boolean = false>(options: Options<CreateBlogData, ThrowOnError>): RequestResult<CreateBlogResponses, CreateBlogErrors, ThrowOnError> => (options.client ?? client).post<CreateBlogResponses, CreateBlogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/blogs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteById = <ThrowOnError extends boolean = false>(options: Options<DeleteByIdData, ThrowOnError>): RequestResult<DeleteByIdResponses, DeleteByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteByIdResponses, DeleteByIdErrors, ThrowOnError>({ url: '/blogs/{id}', ...options });

export const findBlogById = <ThrowOnError extends boolean = false>(options: Options<FindBlogByIdData, ThrowOnError>): RequestResult<FindBlogByIdResponses, FindBlogByIdErrors, ThrowOnError> => (options.client ?? client).get<FindBlogByIdResponses, FindBlogByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/blogs/{id}',
    ...options
});

export const updateBlog = <ThrowOnError extends boolean = false>(options: Options<UpdateBlogData, ThrowOnError>): RequestResult<UpdateBlogResponses, UpdateBlogErrors, ThrowOnError> => (options.client ?? client).post<UpdateBlogResponses, UpdateBlogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/blogs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findAllBoards = <ThrowOnError extends boolean = false>(options?: Options<FindAllBoardsData, ThrowOnError>): RequestResult<FindAllBoardsResponses, FindAllBoardsErrors, ThrowOnError> => (options?.client ?? client).get<FindAllBoardsResponses, FindAllBoardsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards',
    ...options
});

export const createBoard = <ThrowOnError extends boolean = false>(options: Options<CreateBoardData, ThrowOnError>): RequestResult<CreateBoardResponses, CreateBoardErrors, ThrowOnError> => (options.client ?? client).post<CreateBoardResponses, CreateBoardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const addMember = <ThrowOnError extends boolean = false>(options: Options<AddMemberData, ThrowOnError>): RequestResult<AddMemberResponses, AddMemberErrors, ThrowOnError> => (options.client ?? client).post<AddMemberResponses, AddMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards/{boardId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberData, ThrowOnError>): RequestResult<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError>({ url: '/boards/{boardId}/members/{id}', ...options });

export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>): RequestResult<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError> => (options.client ?? client).put<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards/{boardId}/members/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkMember = <ThrowOnError extends boolean = false>(options: Options<LinkMemberData, ThrowOnError>): RequestResult<LinkMemberResponses, LinkMemberErrors, ThrowOnError> => (options.client ?? client).put<LinkMemberResponses, LinkMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards/{boardId}/members/{id}/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteBoard = <ThrowOnError extends boolean = false>(options: Options<DeleteBoardData, ThrowOnError>): RequestResult<DeleteBoardResponses, DeleteBoardErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBoardResponses, DeleteBoardErrors, ThrowOnError>({ url: '/boards/{id}', ...options });

export const findBoardById = <ThrowOnError extends boolean = false>(options: Options<FindBoardByIdData, ThrowOnError>): RequestResult<FindBoardByIdResponses, FindBoardByIdErrors, ThrowOnError> => (options.client ?? client).get<FindBoardByIdResponses, FindBoardByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards/{id}',
    ...options
});

export const updateBoard = <ThrowOnError extends boolean = false>(options: Options<UpdateBoardData, ThrowOnError>): RequestResult<UpdateBoardResponses, UpdateBoardErrors, ThrowOnError> => (options.client ?? client).put<UpdateBoardResponses, UpdateBoardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/boards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findCommitteesByUserId = <ThrowOnError extends boolean = false>(options?: Options<FindCommitteesByUserIdData, ThrowOnError>): RequestResult<FindCommitteesByUserIdResponses, FindCommitteesByUserIdErrors, ThrowOnError> => (options?.client ?? client).get<FindCommitteesByUserIdResponses, FindCommitteesByUserIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committeeMembers/committees',
    ...options
});

export const findCommittees = <ThrowOnError extends boolean = false>(options?: Options<FindCommitteesData, ThrowOnError>): RequestResult<FindCommitteesResponses, FindCommitteesErrors, ThrowOnError> => (options?.client ?? client).get<FindCommitteesResponses, FindCommitteesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees',
    ...options
});

export const createCommittee = <ThrowOnError extends boolean = false>(options: Options<CreateCommitteeData, ThrowOnError>): RequestResult<CreateCommitteeResponses, CreateCommitteeErrors, ThrowOnError> => (options.client ?? client).post<CreateCommitteeResponses, CreateCommitteeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findCommitteePage = <ThrowOnError extends boolean = false>(options: Options<FindCommitteePageData, ThrowOnError>): RequestResult<FindCommitteePageResponses, FindCommitteePageErrors, ThrowOnError> => (options.client ?? client).get<FindCommitteePageResponses, FindCommitteePageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/address/{address}',
    ...options
});

export const setGameOrganisers = <ThrowOnError extends boolean = false>(options: Options<SetGameOrganisersData, ThrowOnError>): RequestResult<SetGameOrganisersResponses, SetGameOrganisersErrors, ThrowOnError> => (options.client ?? client).put<SetGameOrganisersResponses, SetGameOrganisersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/games/{game}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findCommitteeById = <ThrowOnError extends boolean = false>(options: Options<FindCommitteeByIdData, ThrowOnError>): RequestResult<FindCommitteeByIdResponses, FindCommitteeByIdErrors, ThrowOnError> => (options.client ?? client).get<FindCommitteeByIdResponses, FindCommitteeByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/{committeeId}',
    ...options
});

export const deleteCommitteeById = <ThrowOnError extends boolean = false>(options: Options<DeleteCommitteeByIdData, ThrowOnError>): RequestResult<DeleteCommitteeByIdResponses, DeleteCommitteeByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCommitteeByIdResponses, DeleteCommitteeByIdErrors, ThrowOnError>({ url: '/committees/{id}', ...options });

export const updateCommittee = <ThrowOnError extends boolean = false>(options: Options<UpdateCommitteeData, ThrowOnError>): RequestResult<UpdateCommitteeResponses, UpdateCommitteeErrors, ThrowOnError> => (options.client ?? client).put<UpdateCommitteeResponses, UpdateCommitteeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const archiveCommittee = <ThrowOnError extends boolean = false>(options: Options<ArchiveCommitteeData, ThrowOnError>): RequestResult<ArchiveCommitteeResponses, ArchiveCommitteeErrors, ThrowOnError> => (options.client ?? client).put<ArchiveCommitteeResponses, ArchiveCommitteeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/{id}/archived',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const uploadCommitteeBanner = <ThrowOnError extends boolean = false>(options: Options<UploadCommitteeBannerData, ThrowOnError>): RequestResult<UploadCommitteeBannerResponses, UploadCommitteeBannerErrors, ThrowOnError> => (options.client ?? client).post<UploadCommitteeBannerResponses, UploadCommitteeBannerErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/committees/{id}/banners',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const findCommitteeDeletion = <ThrowOnError extends boolean = false>(options: Options<FindCommitteeDeletionData, ThrowOnError>): RequestResult<FindCommitteeDeletionResponses, FindCommitteeDeletionErrors, ThrowOnError> => (options.client ?? client).get<FindCommitteeDeletionResponses, FindCommitteeDeletionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/{id}/deletion',
    ...options
});

export const uploadCommitteeIcon = <ThrowOnError extends boolean = false>(options: Options<UploadCommitteeIconData, ThrowOnError>): RequestResult<UploadCommitteeIconResponses, UploadCommitteeIconErrors, ThrowOnError> => (options.client ?? client).post<UploadCommitteeIconResponses, UploadCommitteeIconErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/committees/{id}/icons',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const updateCommitteePage = <ThrowOnError extends boolean = false>(options: Options<UpdateCommitteePageData, ThrowOnError>): RequestResult<UpdateCommitteePageResponses, UpdateCommitteePageErrors, ThrowOnError> => (options.client ?? client).put<UpdateCommitteePageResponses, UpdateCommitteePageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/committees/{id}/page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findContributionPeriods = <ThrowOnError extends boolean = false>(options?: Options<FindContributionPeriodsData, ThrowOnError>): RequestResult<FindContributionPeriodsResponses, FindContributionPeriodsErrors, ThrowOnError> => (options?.client ?? client).get<FindContributionPeriodsResponses, FindContributionPeriodsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionPeriods',
    ...options
});

export const createContributionPeriod = <ThrowOnError extends boolean = false>(options: Options<CreateContributionPeriodData, ThrowOnError>): RequestResult<CreateContributionPeriodResponses, CreateContributionPeriodErrors, ThrowOnError> => (options.client ?? client).post<CreateContributionPeriodResponses, CreateContributionPeriodErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionPeriods',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findCurrentContributionPeriod = <ThrowOnError extends boolean = false>(options?: Options<FindCurrentContributionPeriodData, ThrowOnError>): RequestResult<FindCurrentContributionPeriodResponses, FindCurrentContributionPeriodErrors, ThrowOnError> => (options?.client ?? client).get<FindCurrentContributionPeriodResponses, FindCurrentContributionPeriodErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionPeriods/current',
    ...options
});

export const deleteContribution = <ThrowOnError extends boolean = false>(options: Options<DeleteContributionData, ThrowOnError>): RequestResult<DeleteContributionResponses, DeleteContributionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContributionResponses, DeleteContributionErrors, ThrowOnError>({ url: '/contributionPeriods/{contributionPeriodId}/users/{userId}/contributions', ...options });

export const deleteContributionPeriodById = <ThrowOnError extends boolean = false>(options: Options<DeleteContributionPeriodByIdData, ThrowOnError>): RequestResult<DeleteContributionPeriodByIdResponses, DeleteContributionPeriodByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContributionPeriodByIdResponses, DeleteContributionPeriodByIdErrors, ThrowOnError>({ url: '/contributionPeriods/{id}', ...options });

export const updateContributionPeriod = <ThrowOnError extends boolean = false>(options: Options<UpdateContributionPeriodData, ThrowOnError>): RequestResult<UpdateContributionPeriodResponses, UpdateContributionPeriodErrors, ThrowOnError> => (options.client ?? client).put<UpdateContributionPeriodResponses, UpdateContributionPeriodErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionPeriods/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findContributionsByPeriodId = <ThrowOnError extends boolean = false>(options: Options<FindContributionsByPeriodIdData, ThrowOnError>): RequestResult<FindContributionsByPeriodIdResponses, FindContributionsByPeriodIdErrors, ThrowOnError> => (options.client ?? client).get<FindContributionsByPeriodIdResponses, FindContributionsByPeriodIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionPeriods/{periodId}/contributions',
    ...options
});

export const findContributionReminders = <ThrowOnError extends boolean = false>(options: Options<FindContributionRemindersData, ThrowOnError>): RequestResult<FindContributionRemindersResponses, FindContributionRemindersErrors, ThrowOnError> => (options.client ?? client).get<FindContributionRemindersResponses, FindContributionRemindersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionReminders',
    ...options
});

export const sendContributionReminder = <ThrowOnError extends boolean = false>(options: Options<SendContributionReminderData, ThrowOnError>): RequestResult<SendContributionReminderResponses, SendContributionReminderErrors, ThrowOnError> => (options.client ?? client).post<SendContributionReminderResponses, SendContributionReminderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionReminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendContributionReminderBatch = <ThrowOnError extends boolean = false>(options: Options<SendContributionReminderBatchData, ThrowOnError>): RequestResult<SendContributionReminderBatchResponses, SendContributionReminderBatchErrors, ThrowOnError> => (options.client ?? client).post<SendContributionReminderBatchResponses, SendContributionReminderBatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributionReminders/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findContributions = <ThrowOnError extends boolean = false>(options: Options<FindContributionsData, ThrowOnError>): RequestResult<FindContributionsResponses, FindContributionsErrors, ThrowOnError> => (options.client ?? client).get<FindContributionsResponses, FindContributionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions',
    ...options
});

export const createContribution = <ThrowOnError extends boolean = false>(options: Options<CreateContributionData, ThrowOnError>): RequestResult<CreateContributionResponses, CreateContributionErrors, ThrowOnError> => (options.client ?? client).post<CreateContributionResponses, CreateContributionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findBankAccount = <ThrowOnError extends boolean = false>(options?: Options<FindBankAccountData, ThrowOnError>): RequestResult<FindBankAccountResponses, FindBankAccountErrors, ThrowOnError> => (options?.client ?? client).get<FindBankAccountResponses, FindBankAccountErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bank-account',
    ...options
});

export const readContributionEmail = <ThrowOnError extends boolean = false>(options: Options<ReadContributionEmailData, ThrowOnError>): RequestResult<ReadContributionEmailResponses, ReadContributionEmailErrors, ThrowOnError> => (options.client ?? client).get<ReadContributionEmailResponses, ReadContributionEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bulk/email/message',
    ...options
});

export const previewBulkContributionEmail = <ThrowOnError extends boolean = false>(options: Options<PreviewBulkContributionEmailData, ThrowOnError>): RequestResult<PreviewBulkContributionEmailResponses, PreviewBulkContributionEmailErrors, ThrowOnError> => (options.client ?? client).post<PreviewBulkContributionEmailResponses, PreviewBulkContributionEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bulk/email/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendPaymentEmails = <ThrowOnError extends boolean = false>(options: Options<SendPaymentEmailsData, ThrowOnError>): RequestResult<SendPaymentEmailsResponses, SendPaymentEmailsErrors, ThrowOnError> => (options.client ?? client).post<SendPaymentEmailsResponses, SendPaymentEmailsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bulk/email/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markPaid = <ThrowOnError extends boolean = false>(options: Options<MarkPaidData, ThrowOnError>): RequestResult<MarkPaidResponses, MarkPaidErrors, ThrowOnError> => (options.client ?? client).post<MarkPaidResponses, MarkPaidErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bulk/mark-paid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markUnpaid = <ThrowOnError extends boolean = false>(options: Options<MarkUnpaidData, ThrowOnError>): RequestResult<MarkUnpaidResponses, MarkUnpaidErrors, ThrowOnError> => (options.client ?? client).post<MarkUnpaidResponses, MarkUnpaidErrors, ThrowOnError>({
    responseType: 'json',
    url: '/contributions/bulk/mark-unpaid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const csrf = <ThrowOnError extends boolean = false>(options: Options<CsrfData, ThrowOnError>): RequestResult<CsrfResponses, CsrfErrors, ThrowOnError> => (options.client ?? client).get<CsrfResponses, CsrfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/csrf',
    ...options
});

export const previewDescription = <ThrowOnError extends boolean = false>(options: Options<PreviewDescriptionData, ThrowOnError>): RequestResult<PreviewDescriptionResponses, PreviewDescriptionErrors, ThrowOnError> => (options.client ?? client).post<PreviewDescriptionResponses, PreviewDescriptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/descriptions/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redirects to the door's channel in Discord, for a member
 */
export const openDiscordChannel = <ThrowOnError extends boolean = false>(options: Options<OpenDiscordChannelData, ThrowOnError>): RequestResult<unknown, OpenDiscordChannelErrors, ThrowOnError> => (options.client ?? client).get<unknown, OpenDiscordChannelErrors, ThrowOnError>({ url: '/discord/channel/{door}', ...options });

/**
 * The Discord server's channels everybody can see, in the server's order
 */
export const listDiscordChannels = <ThrowOnError extends boolean = false>(options?: Options<ListDiscordChannelsData, ThrowOnError>): RequestResult<ListDiscordChannelsResponses, ListDiscordChannelsErrors, ThrowOnError> => (options?.client ?? client).get<ListDiscordChannelsResponses, ListDiscordChannelsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/channels',
    ...options
});

/**
 * The Discord server's own emoji, the bot's application emoji and the emoji seen used in the server, by name
 */
export const listDiscordEmojis = <ThrowOnError extends boolean = false>(options?: Options<ListDiscordEmojisData, ThrowOnError>): RequestResult<ListDiscordEmojisResponses, ListDiscordEmojisErrors, ThrowOnError> => (options?.client ?? client).get<ListDiscordEmojisResponses, ListDiscordEmojisErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/emojis',
    ...options
});

/**
 * The text channels in the server's games or esports category, in the server's order
 */
export const listGameChannels = <ThrowOnError extends boolean = false>(options?: Options<ListGameChannelsData, ThrowOnError>): RequestResult<ListGameChannelsResponses, ListGameChannelsErrors, ThrowOnError> => (options?.client ?? client).get<ListGameChannelsResponses, ListGameChannelsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/game-channels',
    ...options
});

/**
 * Redirects to an invite into the door's channel
 */
export const openDiscordInvite = <ThrowOnError extends boolean = false>(options: Options<OpenDiscordInviteData, ThrowOnError>): RequestResult<unknown, OpenDiscordInviteErrors, ThrowOnError> => (options.client ?? client).get<unknown, OpenDiscordInviteErrors, ThrowOnError>({ url: '/discord/invite/{door}', ...options });

/**
 * The Discord server's counts and voice rooms, with who is in them
 */
export const readDiscordLive = <ThrowOnError extends boolean = false>(options?: Options<ReadDiscordLiveData, ThrowOnError>): RequestResult<ReadDiscordLiveResponses, ReadDiscordLiveErrors, ThrowOnError> => (options?.client ?? client).get<ReadDiscordLiveResponses, ReadDiscordLiveErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/live',
    ...options
});

/**
 * The voice rooms the viewer's own Discord member may join
 */
export const readMyDiscordRooms = <ThrowOnError extends boolean = false>(options?: Options<ReadMyDiscordRoomsData, ThrowOnError>): RequestResult<ReadMyDiscordRoomsResponses, ReadMyDiscordRoomsErrors, ThrowOnError> => (options?.client ?? client).get<ReadMyDiscordRoomsResponses, ReadMyDiscordRoomsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/live/mine',
    ...options
});

/**
 * Members of the Discord server whose username or server name starts with the query
 */
export const searchDiscordMembers = <ThrowOnError extends boolean = false>(options: Options<SearchDiscordMembersData, ThrowOnError>): RequestResult<SearchDiscordMembersResponses, SearchDiscordMembersErrors, ThrowOnError> => (options.client ?? client).get<SearchDiscordMembersResponses, SearchDiscordMembersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/members',
    ...options
});

/**
 * Members of the Discord server no website account has linked yet, by name
 */
export const listUnclaimedDiscordMembers = <ThrowOnError extends boolean = false>(options?: Options<ListUnclaimedDiscordMembersData, ThrowOnError>): RequestResult<ListUnclaimedDiscordMembersResponses, ListUnclaimedDiscordMembersErrors, ThrowOnError> => (options?.client ?? client).get<ListUnclaimedDiscordMembersResponses, ListUnclaimedDiscordMembersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/members/unclaimed',
    ...options
});

/**
 * The names of the members, roles and channels a description mentions; an ID the server lacks is left out
 */
export const readDiscordMentions = <ThrowOnError extends boolean = false>(options?: Options<ReadDiscordMentionsData, ThrowOnError>): RequestResult<ReadDiscordMentionsResponses, ReadDiscordMentionsErrors, ThrowOnError> => (options?.client ?? client).get<ReadDiscordMentionsResponses, ReadDiscordMentionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/mentions',
    ...options
});

/**
 * The Discord server's roles an event may ping, in the server's order
 */
export const listDiscordRoles = <ThrowOnError extends boolean = false>(options?: Options<ListDiscordRolesData, ThrowOnError>): RequestResult<ListDiscordRolesResponses, ListDiscordRolesErrors, ThrowOnError> => (options?.client ?? client).get<ListDiscordRolesResponses, ListDiscordRolesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/roles',
    ...options
});

/**
 * What the Discord server starred lately, most stars first, for a member
 */
export const readStarboard = <ThrowOnError extends boolean = false>(options?: Options<ReadStarboardData, ThrowOnError>): RequestResult<ReadStarboardResponses, ReadStarboardErrors, ThrowOnError> => (options?.client ?? client).get<ReadStarboardResponses, ReadStarboardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/discord/starboard',
    ...options
});

export const findGame = <ThrowOnError extends boolean = false>(options: Options<FindGameData, ThrowOnError>): RequestResult<FindGameResponses, FindGameErrors, ThrowOnError> => (options.client ?? client).get<FindGameResponses, FindGameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/games/{game}',
    ...options
});

export const removeRosterEntry = <ThrowOnError extends boolean = false>(options: Options<RemoveRosterEntryData, ThrowOnError>): RequestResult<RemoveRosterEntryResponses, RemoveRosterEntryErrors, ThrowOnError> => (options.client ?? client).delete<RemoveRosterEntryResponses, RemoveRosterEntryErrors, ThrowOnError>({ url: '/esports/roster/{id}', ...options });

export const updateRosterEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateRosterEntryData, ThrowOnError>): RequestResult<UpdateRosterEntryResponses, UpdateRosterEntryErrors, ThrowOnError> => (options.client ?? client).put<UpdateRosterEntryResponses, UpdateRosterEntryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/roster/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkRosterEntry = <ThrowOnError extends boolean = false>(options: Options<LinkRosterEntryData, ThrowOnError>): RequestResult<LinkRosterEntryResponses, LinkRosterEntryErrors, ThrowOnError> => (options.client ?? client).put<LinkRosterEntryResponses, LinkRosterEntryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/roster/{id}/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findSeasons = <ThrowOnError extends boolean = false>(options?: Options<FindSeasonsData, ThrowOnError>): RequestResult<FindSeasonsResponses, FindSeasonsErrors, ThrowOnError> => (options?.client ?? client).get<FindSeasonsResponses, FindSeasonsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons',
    ...options
});

export const createSeason = <ThrowOnError extends boolean = false>(options: Options<CreateSeasonData, ThrowOnError>): RequestResult<CreateSeasonResponses, CreateSeasonErrors, ThrowOnError> => (options.client ?? client).post<CreateSeasonResponses, CreateSeasonErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSeason = <ThrowOnError extends boolean = false>(options: Options<DeleteSeasonData, ThrowOnError>): RequestResult<DeleteSeasonResponses, DeleteSeasonErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSeasonResponses, DeleteSeasonErrors, ThrowOnError>({ url: '/esports/seasons/{id}', ...options });

export const updateSeason = <ThrowOnError extends boolean = false>(options: Options<UpdateSeasonData, ThrowOnError>): RequestResult<UpdateSeasonResponses, UpdateSeasonErrors, ThrowOnError> => (options.client ?? client).put<UpdateSeasonResponses, UpdateSeasonErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findSeasonContents = <ThrowOnError extends boolean = false>(options: Options<FindSeasonContentsData, ThrowOnError>): RequestResult<FindSeasonContentsResponses, FindSeasonContentsErrors, ThrowOnError> => (options.client ?? client).get<FindSeasonContentsResponses, FindSeasonContentsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{id}/contents',
    ...options
});

export const findSeasonGames = <ThrowOnError extends boolean = false>(options: Options<FindSeasonGamesData, ThrowOnError>): RequestResult<FindSeasonGamesResponses, FindSeasonGamesErrors, ThrowOnError> => (options.client ?? client).get<FindSeasonGamesResponses, FindSeasonGamesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{seasonId}/games',
    ...options
});

export const leaveGame = <ThrowOnError extends boolean = false>(options: Options<LeaveGameData, ThrowOnError>): RequestResult<LeaveGameResponses, LeaveGameErrors, ThrowOnError> => (options.client ?? client).delete<LeaveGameResponses, LeaveGameErrors, ThrowOnError>({ url: '/esports/seasons/{seasonId}/games/{game}', ...options });

export const enterGame = <ThrowOnError extends boolean = false>(options: Options<EnterGameData, ThrowOnError>): RequestResult<EnterGameResponses, EnterGameErrors, ThrowOnError> => (options.client ?? client).put<EnterGameResponses, EnterGameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{seasonId}/games/{game}',
    ...options
});

export const publishLineup = <ThrowOnError extends boolean = false>(options: Options<PublishLineupData, ThrowOnError>): RequestResult<PublishLineupResponses, PublishLineupErrors, ThrowOnError> => (options.client ?? client).put<PublishLineupResponses, PublishLineupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{seasonId}/lineup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const unfieldTeam = <ThrowOnError extends boolean = false>(options: Options<UnfieldTeamData, ThrowOnError>): RequestResult<UnfieldTeamResponses, UnfieldTeamErrors, ThrowOnError> => (options.client ?? client).delete<UnfieldTeamResponses, UnfieldTeamErrors, ThrowOnError>({ url: '/esports/seasons/{seasonId}/teams/{teamId}', ...options });

export const fieldTeam = <ThrowOnError extends boolean = false>(options: Options<FieldTeamData, ThrowOnError>): RequestResult<FieldTeamResponses, FieldTeamErrors, ThrowOnError> => (options.client ?? client).put<FieldTeamResponses, FieldTeamErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/seasons/{seasonId}/teams/{teamId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findTeams = <ThrowOnError extends boolean = false>(options?: Options<FindTeamsData, ThrowOnError>): RequestResult<FindTeamsResponses, FindTeamsErrors, ThrowOnError> => (options?.client ?? client).get<FindTeamsResponses, FindTeamsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams',
    ...options
});

export const createTeam = <ThrowOnError extends boolean = false>(options: Options<CreateTeamData, ThrowOnError>): RequestResult<CreateTeamResponses, CreateTeamErrors, ThrowOnError> => (options.client ?? client).post<CreateTeamResponses, CreateTeamErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteTeam = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamData, ThrowOnError>): RequestResult<DeleteTeamResponses, DeleteTeamErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTeamResponses, DeleteTeamErrors, ThrowOnError>({ url: '/esports/teams/{id}', ...options });

export const updateTeam = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamData, ThrowOnError>): RequestResult<UpdateTeamResponses, UpdateTeamErrors, ThrowOnError> => (options.client ?? client).put<UpdateTeamResponses, UpdateTeamErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findRoster = <ThrowOnError extends boolean = false>(options: Options<FindRosterData, ThrowOnError>): RequestResult<FindRosterResponses, FindRosterErrors, ThrowOnError> => (options.client ?? client).get<FindRosterResponses, FindRosterErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams/{teamId}/roster',
    ...options
});

export const addRosterEntry = <ThrowOnError extends boolean = false>(options: Options<AddRosterEntryData, ThrowOnError>): RequestResult<AddRosterEntryResponses, AddRosterEntryErrors, ThrowOnError> => (options.client ?? client).post<AddRosterEntryResponses, AddRosterEntryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams/{teamId}/roster',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findTeamSeasons = <ThrowOnError extends boolean = false>(options: Options<FindTeamSeasonsData, ThrowOnError>): RequestResult<FindTeamSeasonsResponses, FindTeamSeasonsErrors, ThrowOnError> => (options.client ?? client).get<FindTeamSeasonsResponses, FindTeamSeasonsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/esports/teams/{teamId}/seasons',
    ...options
});

export const findEvents = <ThrowOnError extends boolean = false>(options?: Options<FindEventsData, ThrowOnError>): RequestResult<FindEventsResponses, FindEventsErrors, ThrowOnError> => (options?.client ?? client).get<FindEventsResponses, FindEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events',
    ...options
});

export const createEvent = <ThrowOnError extends boolean = false>(options: Options<CreateEventData, ThrowOnError>): RequestResult<CreateEventResponses, CreateEventErrors, ThrowOnError> => (options.client ?? client).post<CreateEventResponses, CreateEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const uploadEventBanner = <ThrowOnError extends boolean = false>(options: Options<UploadEventBannerData, ThrowOnError>): RequestResult<UploadEventBannerResponses, UploadEventBannerErrors, ThrowOnError> => (options.client ?? client).post<UploadEventBannerResponses, UploadEventBannerErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/events/banners',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const findEventSignUps = <ThrowOnError extends boolean = false>(options?: Options<FindEventSignUpsData, ThrowOnError>): RequestResult<FindEventSignUpsResponses, FindEventSignUpsErrors, ThrowOnError> => (options?.client ?? client).get<FindEventSignUpsResponses, FindEventSignUpsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/signups',
    ...options
});

export const findEventSignUpsByAccessToken = <ThrowOnError extends boolean = false>(options: Options<FindEventSignUpsByAccessTokenData, ThrowOnError>): RequestResult<FindEventSignUpsByAccessTokenResponses, FindEventSignUpsByAccessTokenErrors, ThrowOnError> => (options.client ?? client).get<FindEventSignUpsByAccessTokenResponses, FindEventSignUpsByAccessTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/signups/byAccessToken',
    ...options
});

export const deleteEventSignup = <ThrowOnError extends boolean = false>(options: Options<DeleteEventSignupData, ThrowOnError>): RequestResult<DeleteEventSignupResponses, DeleteEventSignupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventSignupResponses, DeleteEventSignupErrors, ThrowOnError>({ url: '/events/signups/{id}', ...options });

export const updateEventSignUpById = <ThrowOnError extends boolean = false>(options: Options<UpdateEventSignUpByIdData, ThrowOnError>): RequestResult<UpdateEventSignUpByIdResponses, UpdateEventSignUpByIdErrors, ThrowOnError> => (options.client ?? client).put<UpdateEventSignUpByIdResponses, UpdateEventSignUpByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/signups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteEventById = <ThrowOnError extends boolean = false>(options: Options<DeleteEventByIdData, ThrowOnError>): RequestResult<DeleteEventByIdResponses, DeleteEventByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventByIdResponses, DeleteEventByIdErrors, ThrowOnError>({ url: '/events/{eventId}', ...options });

export const downloadEventBanner = <ThrowOnError extends boolean = false>(options: Options<DownloadEventBannerData, ThrowOnError>): RequestResult<DownloadEventBannerResponses, DownloadEventBannerErrors, ThrowOnError> => (options.client ?? client).get<DownloadEventBannerResponses, DownloadEventBannerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{eventId}/banners',
    ...options
});

export const findEventSignUpsByEventId = <ThrowOnError extends boolean = false>(options: Options<FindEventSignUpsByEventIdData, ThrowOnError>): RequestResult<FindEventSignUpsByEventIdResponses, FindEventSignUpsByEventIdErrors, ThrowOnError> => (options.client ?? client).get<FindEventSignUpsByEventIdResponses, FindEventSignUpsByEventIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{eventId}/signups',
    ...options
});

export const createEventSignup = <ThrowOnError extends boolean = false>(options: Options<CreateEventSignupData, ThrowOnError>): RequestResult<CreateEventSignupResponses, CreateEventSignupErrors, ThrowOnError> => (options.client ?? client).post<CreateEventSignupResponses, CreateEventSignupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{eventId}/signups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateEventSignUp = <ThrowOnError extends boolean = false>(options: Options<UpdateEventSignUpData, ThrowOnError>): RequestResult<UpdateEventSignUpResponses, UpdateEventSignUpErrors, ThrowOnError> => (options.client ?? client).put<UpdateEventSignUpResponses, UpdateEventSignUpErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{eventId}/signups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findEventById = <ThrowOnError extends boolean = false>(options: Options<FindEventByIdData, ThrowOnError>): RequestResult<FindEventByIdResponses, FindEventByIdErrors, ThrowOnError> => (options.client ?? client).get<FindEventByIdResponses, FindEventByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{id}',
    ...options
});

export const updateEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateEventData, ThrowOnError>): RequestResult<UpdateEventResponses, UpdateEventErrors, ThrowOnError> => (options.client ?? client).put<UpdateEventResponses, UpdateEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const approveEvent = <ThrowOnError extends boolean = false>(options: Options<ApproveEventData, ThrowOnError>): RequestResult<ApproveEventResponses, ApproveEventErrors, ThrowOnError> => (options.client ?? client).put<ApproveEventResponses, ApproveEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{id}/approve',
    ...options
});

export const findEventRoster = <ThrowOnError extends boolean = false>(options: Options<FindEventRosterData, ThrowOnError>): RequestResult<FindEventRosterResponses, FindEventRosterErrors, ThrowOnError> => (options.client ?? client).get<FindEventRosterResponses, FindEventRosterErrors, ThrowOnError>({
    responseType: 'json',
    url: '/events/{id}/roster',
    ...options
});

export const uploadPublicImage = <ThrowOnError extends boolean = false>(options: Options<UploadPublicImageData, ThrowOnError>): RequestResult<UploadPublicImageResponses, UploadPublicImageErrors, ThrowOnError> => (options.client ?? client).post<UploadPublicImageResponses, UploadPublicImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/files/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const downloadPublicFile = <ThrowOnError extends boolean = false>(options: Options<DownloadPublicFileData, ThrowOnError>): RequestResult<DownloadPublicFileResponses, DownloadPublicFileErrors, ThrowOnError> => (options.client ?? client).get<DownloadPublicFileResponses, DownloadPublicFileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/files/public/{directory}/{filename}',
    ...options
});

export const findCasualGames = <ThrowOnError extends boolean = false>(options?: Options<FindCasualGamesData, ThrowOnError>): RequestResult<FindCasualGamesResponses, FindCasualGamesErrors, ThrowOnError> => (options?.client ?? client).get<FindCasualGamesResponses, FindCasualGamesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/games',
    ...options
});

export const createCasualGame = <ThrowOnError extends boolean = false>(options: Options<CreateCasualGameData, ThrowOnError>): RequestResult<CreateCasualGameResponses, CreateCasualGameErrors, ThrowOnError> => (options.client ?? client).post<CreateCasualGameResponses, CreateCasualGameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/games',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeGame = <ThrowOnError extends boolean = false>(options: Options<RemoveGameData, ThrowOnError>): RequestResult<RemoveGameResponses, RemoveGameErrors, ThrowOnError> => (options.client ?? client).delete<RemoveGameResponses, RemoveGameErrors, ThrowOnError>({ url: '/games/{game}', ...options });

export const updateCasualGame = <ThrowOnError extends boolean = false>(options: Options<UpdateCasualGameData, ThrowOnError>): RequestResult<UpdateCasualGameResponses, UpdateCasualGameErrors, ThrowOnError> => (options.client ?? client).put<UpdateCasualGameResponses, UpdateCasualGameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/games/{game}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const archiveGame = <ThrowOnError extends boolean = false>(options: Options<ArchiveGameData, ThrowOnError>): RequestResult<ArchiveGameResponses, ArchiveGameErrors, ThrowOnError> => (options.client ?? client).put<ArchiveGameResponses, ArchiveGameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/games/{game}/archived',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findGameHoldings = <ThrowOnError extends boolean = false>(options: Options<FindGameHoldingsData, ThrowOnError>): RequestResult<FindGameHoldingsResponses, FindGameHoldingsErrors, ThrowOnError> => (options.client ?? client).get<FindGameHoldingsResponses, FindGameHoldingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/games/{game}/holdings',
    ...options
});

export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>): RequestResult<HealthCheckResponses, HealthCheckErrors, ThrowOnError> => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
    responseType: 'json',
    url: '/health',
    ...options
});

export const findCohortSubjects = <ThrowOnError extends boolean = false>(options?: Options<FindCohortSubjectsData, ThrowOnError>): RequestResult<FindCohortSubjectsResponses, FindCohortSubjectsErrors, ThrowOnError> => (options?.client ?? client).get<FindCohortSubjectsResponses, FindCohortSubjectsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects',
    ...options
});

export const findCohortSubjectById = <ThrowOnError extends boolean = false>(options: Options<FindCohortSubjectByIdData, ThrowOnError>): RequestResult<FindCohortSubjectByIdResponses, FindCohortSubjectByIdErrors, ThrowOnError> => (options.client ?? client).get<FindCohortSubjectByIdResponses, FindCohortSubjectByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}',
    ...options
});

export const linkUser = <ThrowOnError extends boolean = false>(options: Options<LinkUserData, ThrowOnError>): RequestResult<LinkUserResponses, LinkUserErrors, ThrowOnError> => (options.client ?? client).post<LinkUserResponses, LinkUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/drift/link-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkExistingTarget = <ThrowOnError extends boolean = false>(options: Options<LinkExistingTargetData, ThrowOnError>): RequestResult<LinkExistingTargetResponses, LinkExistingTargetErrors, ThrowOnError> => (options.client ?? client).post<LinkExistingTargetResponses, LinkExistingTargetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/targets/existing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createTarget = <ThrowOnError extends boolean = false>(options: Options<CreateTargetData, ThrowOnError>): RequestResult<CreateTargetResponses, CreateTargetErrors, ThrowOnError> => (options.client ?? client).post<CreateTargetResponses, CreateTargetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/targets/new',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const switchTarget = <ThrowOnError extends boolean = false>(options: Options<SwitchTargetData, ThrowOnError>): RequestResult<SwitchTargetResponses, SwitchTargetErrors, ThrowOnError> => (options.client ?? client).put<SwitchTargetResponses, SwitchTargetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/targets/{cohortId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const applyInboundReconcile = <ThrowOnError extends boolean = false>(options: Options<ApplyInboundReconcileData, ThrowOnError>): RequestResult<ApplyInboundReconcileResponses, ApplyInboundReconcileErrors, ThrowOnError> => (options.client ?? client).post<ApplyInboundReconcileResponses, ApplyInboundReconcileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/targets/{cohortId}/inbound-reconcile/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const previewInboundReconcile = <ThrowOnError extends boolean = false>(options: Options<PreviewInboundReconcileData, ThrowOnError>): RequestResult<PreviewInboundReconcileResponses, PreviewInboundReconcileErrors, ThrowOnError> => (options.client ?? client).post<PreviewInboundReconcileResponses, PreviewInboundReconcileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-subjects/{id}/targets/{cohortId}/inbound-reconcile/preview',
    ...options
});

export const listCohortTargetSystems = <ThrowOnError extends boolean = false>(options?: Options<ListCohortTargetSystemsData, ThrowOnError>): RequestResult<ListCohortTargetSystemsResponses, ListCohortTargetSystemsErrors, ThrowOnError> => (options?.client ?? client).get<ListCohortTargetSystemsResponses, ListCohortTargetSystemsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-targets/systems',
    ...options
});

export const searchCohortTargets = <ThrowOnError extends boolean = false>(options: Options<SearchCohortTargetsData, ThrowOnError>): RequestResult<SearchCohortTargetsResponses, SearchCohortTargetsErrors, ThrowOnError> => (options.client ?? client).get<SearchCohortTargetsResponses, SearchCohortTargetsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-targets/{system}',
    ...options
});

export const moveCohortTargets = <ThrowOnError extends boolean = false>(options: Options<MoveCohortTargetsData, ThrowOnError>): RequestResult<MoveCohortTargetsResponses, MoveCohortTargetsErrors, ThrowOnError> => (options.client ?? client).put<MoveCohortTargetsResponses, MoveCohortTargetsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-targets/{system}/folder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listCohortTargetFolders = <ThrowOnError extends boolean = false>(options: Options<ListCohortTargetFoldersData, ThrowOnError>): RequestResult<ListCohortTargetFoldersResponses, ListCohortTargetFoldersErrors, ThrowOnError> => (options.client ?? client).get<ListCohortTargetFoldersResponses, ListCohortTargetFoldersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-targets/{system}/folders',
    ...options
});

export const moveCohortTarget = <ThrowOnError extends boolean = false>(options: Options<MoveCohortTargetData, ThrowOnError>): RequestResult<MoveCohortTargetResponses, MoveCohortTargetErrors, ThrowOnError> => (options.client ?? client).put<MoveCohortTargetResponses, MoveCohortTargetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohort-targets/{system}/{externalId}/folder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findCohorts = <ThrowOnError extends boolean = false>(options?: Options<FindCohortsData, ThrowOnError>): RequestResult<FindCohortsResponses, FindCohortsErrors, ThrowOnError> => (options?.client ?? client).get<FindCohortsResponses, FindCohortsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohorts',
    ...options
});

export const findCohortById = <ThrowOnError extends boolean = false>(options: Options<FindCohortByIdData, ThrowOnError>): RequestResult<FindCohortByIdResponses, FindCohortByIdErrors, ThrowOnError> => (options.client ?? client).get<FindCohortByIdResponses, FindCohortByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohorts/{id}',
    ...options
});

export const repairMissingAdds = <ThrowOnError extends boolean = false>(options: Options<RepairMissingAddsData, ThrowOnError>): RequestResult<RepairMissingAddsResponses, RepairMissingAddsErrors, ThrowOnError> => (options.client ?? client).post<RepairMissingAddsResponses, RepairMissingAddsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/cohorts/{id}/repair-missing-adds',
    ...options
});

export const list1 = <ThrowOnError extends boolean = false>(options?: Options<List1Data, ThrowOnError>): RequestResult<List1Responses, List1Errors, ThrowOnError> => (options?.client ?? client).get<List1Responses, List1Errors, ThrowOnError>({
    responseType: 'json',
    url: '/management/emails',
    ...options
});

export const getStats1 = <ThrowOnError extends boolean = false>(options?: Options<GetStats1Data, ThrowOnError>): RequestResult<GetStats1Responses, GetStats1Errors, ThrowOnError> => (options?.client ?? client).get<GetStats1Responses, GetStats1Errors, ThrowOnError>({
    responseType: 'json',
    url: '/management/emails/stats',
    ...options
});

export const previewSentEmail = <ThrowOnError extends boolean = false>(options: Options<PreviewSentEmailData, ThrowOnError>): RequestResult<PreviewSentEmailResponses, PreviewSentEmailErrors, ThrowOnError> => (options.client ?? client).get<PreviewSentEmailResponses, PreviewSentEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/emails/{id}/preview',
    ...options
});

export const retry1 = <ThrowOnError extends boolean = false>(options: Options<Retry1Data, ThrowOnError>): RequestResult<Retry1Responses, Retry1Errors, ThrowOnError> => (options.client ?? client).post<Retry1Responses, Retry1Errors, ThrowOnError>({
    responseType: 'json',
    url: '/management/emails/{id}/retry',
    ...options
});

export const list = <ThrowOnError extends boolean = false>(options?: Options<ListData, ThrowOnError>): RequestResult<ListResponses, ListErrors, ThrowOnError> => (options?.client ?? client).get<ListResponses, ListErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/jobs',
    ...options
});

export const enqueue = <ThrowOnError extends boolean = false>(options: Options<EnqueueData, ThrowOnError>): RequestResult<EnqueueResponses, EnqueueErrors, ThrowOnError> => (options.client ?? client).post<EnqueueResponses, EnqueueErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/jobs/enqueue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getStats = <ThrowOnError extends boolean = false>(options?: Options<GetStatsData, ThrowOnError>): RequestResult<GetStatsResponses, GetStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetStatsResponses, GetStatsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/jobs/stats',
    ...options
});

export const jobTypes = <ThrowOnError extends boolean = false>(options?: Options<JobTypesData, ThrowOnError>): RequestResult<JobTypesResponses, JobTypesErrors, ThrowOnError> => (options?.client ?? client).get<JobTypesResponses, JobTypesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/jobs/types',
    ...options
});

export const retry = <ThrowOnError extends boolean = false>(options: Options<RetryData, ThrowOnError>): RequestResult<RetryResponses, RetryErrors, ThrowOnError> => (options.client ?? client).post<RetryResponses, RetryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/management/jobs/{id}/retry',
    ...options
});

export const myServices = <ThrowOnError extends boolean = false>(options?: Options<MyServicesData, ThrowOnError>): RequestResult<MyServicesResponses, MyServicesErrors, ThrowOnError> => (options?.client ?? client).get<MyServicesResponses, MyServicesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/me/services',
    ...options
});

export const createMemberProfile = <ThrowOnError extends boolean = false>(options: Options<CreateMemberProfileData, ThrowOnError>): RequestResult<CreateMemberProfileResponses, CreateMemberProfileErrors, ThrowOnError> => (options.client ?? client).post<CreateMemberProfileResponses, CreateMemberProfileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberProfiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findMemberships = <ThrowOnError extends boolean = false>(options?: Options<FindMembershipsData, ThrowOnError>): RequestResult<FindMembershipsResponses, FindMembershipsErrors, ThrowOnError> => (options?.client ?? client).get<FindMembershipsResponses, FindMembershipsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships',
    ...options
});

export const createMembership = <ThrowOnError extends boolean = false>(options: Options<CreateMembershipData, ThrowOnError>): RequestResult<CreateMembershipResponses, CreateMembershipErrors, ThrowOnError> => (options.client ?? client).post<CreateMembershipResponses, CreateMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const endMemberships = <ThrowOnError extends boolean = false>(options: Options<EndMembershipsData, ThrowOnError>): RequestResult<EndMembershipsResponses, EndMembershipsErrors, ThrowOnError> => (options.client ?? client).post<EndMembershipsResponses, EndMembershipsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/bulk/end',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const previewBulkEnd = <ThrowOnError extends boolean = false>(options: Options<PreviewBulkEndData, ThrowOnError>): RequestResult<PreviewBulkEndResponses, PreviewBulkEndErrors, ThrowOnError> => (options.client ?? client).post<PreviewBulkEndResponses, PreviewBulkEndErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/bulk/end/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const startMemberships = <ThrowOnError extends boolean = false>(options: Options<StartMembershipsData, ThrowOnError>): RequestResult<StartMembershipsResponses, StartMembershipsErrors, ThrowOnError> => (options.client ?? client).post<StartMembershipsResponses, StartMembershipsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/bulk/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const previewBulkStart = <ThrowOnError extends boolean = false>(options: Options<PreviewBulkStartData, ThrowOnError>): RequestResult<PreviewBulkStartResponses, PreviewBulkStartErrors, ThrowOnError> => (options.client ?? client).post<PreviewBulkStartResponses, PreviewBulkStartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/bulk/start/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteMembership = <ThrowOnError extends boolean = false>(options: Options<DeleteMembershipData, ThrowOnError>): RequestResult<DeleteMembershipResponses, DeleteMembershipErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMembershipResponses, DeleteMembershipErrors, ThrowOnError>({ url: '/memberships/{id}', ...options });

export const findMembershipById = <ThrowOnError extends boolean = false>(options: Options<FindMembershipByIdData, ThrowOnError>): RequestResult<FindMembershipByIdResponses, FindMembershipByIdErrors, ThrowOnError> => (options.client ?? client).get<FindMembershipByIdResponses, FindMembershipByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/{id}',
    ...options
});

export const updateMembership = <ThrowOnError extends boolean = false>(options: Options<UpdateMembershipData, ThrowOnError>): RequestResult<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError> => (options.client ?? client).put<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const endMembership = <ThrowOnError extends boolean = false>(options: Options<EndMembershipData, ThrowOnError>): RequestResult<EndMembershipResponses, EndMembershipErrors, ThrowOnError> => (options.client ?? client).post<EndMembershipResponses, EndMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/{id}/end',
    ...options
});

export const reopenMembership = <ThrowOnError extends boolean = false>(options: Options<ReopenMembershipData, ThrowOnError>): RequestResult<ReopenMembershipResponses, ReopenMembershipErrors, ThrowOnError> => (options.client ?? client).post<ReopenMembershipResponses, ReopenMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/{id}/reopen',
    ...options
});

export const restoreMembership = <ThrowOnError extends boolean = false>(options: Options<RestoreMembershipData, ThrowOnError>): RequestResult<RestoreMembershipResponses, RestoreMembershipErrors, ThrowOnError> => (options.client ?? client).put<RestoreMembershipResponses, RestoreMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/memberships/{id}/restore',
    ...options
});

export const forwardAuth = <ThrowOnError extends boolean = false>(options?: Options<ForwardAuthData, ThrowOnError>): RequestResult<ForwardAuthResponses, ForwardAuthErrors, ThrowOnError> => (options?.client ?? client).get<ForwardAuthResponses, ForwardAuthErrors, ThrowOnError>({ url: '/oauth2/forward-auth', ...options });

export const board = <ThrowOnError extends boolean = false>(options?: Options<BoardData, ThrowOnError>): RequestResult<BoardResponses, BoardErrors, ThrowOnError> => (options?.client ?? client).get<BoardResponses, BoardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/pinger/leaderboard',
    ...options
});

export const confirmEmailChange = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailChangeData, ThrowOnError>): RequestResult<ConfirmEmailChangeResponses, ConfirmEmailChangeErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailChangeResponses, ConfirmEmailChangeErrors, ThrowOnError>({
    url: '/recovery/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const lock = <ThrowOnError extends boolean = false>(options: Options<LockData, ThrowOnError>): RequestResult<LockResponses, LockErrors, ThrowOnError> => (options.client ?? client).post<LockResponses, LockErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/lock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const memberActivate = <ThrowOnError extends boolean = false>(options: Options<MemberActivateData, ThrowOnError>): RequestResult<MemberActivateResponses, MemberActivateErrors, ThrowOnError> => (options.client ?? client).post<MemberActivateResponses, MemberActivateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/member/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/recovery/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({ url: '/recovery/password/reset/{username}', ...options });

export const pendingActivations = <ThrowOnError extends boolean = false>(options?: Options<PendingActivationsData, ThrowOnError>): RequestResult<PendingActivationsResponses, PendingActivationsErrors, ThrowOnError> => (options?.client ?? client).get<PendingActivationsResponses, PendingActivationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/pending-activations',
    ...options
});

export const reenrol = <ThrowOnError extends boolean = false>(options: Options<ReenrolData, ThrowOnError>): RequestResult<ReenrolResponses, ReenrolErrors, ThrowOnError> => (options.client ?? client).post<ReenrolResponses, ReenrolErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/two-factor/re-enrol',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userActivate = <ThrowOnError extends boolean = false>(options: Options<UserActivateData, ThrowOnError>): RequestResult<UserActivateResponses, UserActivateErrors, ThrowOnError> => (options.client ?? client).post<UserActivateResponses, UserActivateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/user/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resendUserActivation = <ThrowOnError extends boolean = false>(options: Options<ResendUserActivationData, ThrowOnError>): RequestResult<ResendUserActivationResponses, ResendUserActivationErrors, ThrowOnError> => (options.client ?? client).post<ResendUserActivationResponses, ResendUserActivationErrors, ThrowOnError>({ url: '/recovery/user/activate/resend/{username}', ...options });

export const previewRecoveryEmail = <ThrowOnError extends boolean = false>(options: Options<PreviewRecoveryEmailData, ThrowOnError>): RequestResult<PreviewRecoveryEmailResponses, PreviewRecoveryEmailErrors, ThrowOnError> => (options.client ?? client).get<PreviewRecoveryEmailResponses, PreviewRecoveryEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/recovery/users/{userId}/email-preview',
    ...options
});

export const resendRecoveryEmail = <ThrowOnError extends boolean = false>(options: Options<ResendRecoveryEmailData, ThrowOnError>): RequestResult<ResendRecoveryEmailResponses, ResendRecoveryEmailErrors, ThrowOnError> => (options.client ?? client).post<ResendRecoveryEmailResponses, ResendRecoveryEmailErrors, ThrowOnError>({ url: '/recovery/users/{userId}/resend/recovery', ...options });

export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    responseType: 'json',
    url: '/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const saveAddress = <ThrowOnError extends boolean = false>(options: Options<SaveAddressData, ThrowOnError>): RequestResult<SaveAddressResponses, SaveAddressErrors, ThrowOnError> => (options.client ?? client).post<SaveAddressResponses, SaveAddressErrors, ThrowOnError>({
    url: '/signup/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const apply = <ThrowOnError extends boolean = false>(options: Options<ApplyData, ThrowOnError>): RequestResult<ApplyResponses, ApplyErrors, ThrowOnError> => (options.client ?? client).post<ApplyResponses, ApplyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/signup/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateDetails = <ThrowOnError extends boolean = false>(options: Options<UpdateDetailsData, ThrowOnError>): RequestResult<UpdateDetailsResponses, UpdateDetailsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDetailsResponses, UpdateDetailsErrors, ThrowOnError>({
    url: '/signup/details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const correctEmail = <ThrowOnError extends boolean = false>(options: Options<CorrectEmailData, ThrowOnError>): RequestResult<CorrectEmailResponses, CorrectEmailErrors, ThrowOnError> => (options.client ?? client).patch<CorrectEmailResponses, CorrectEmailErrors, ThrowOnError>({
    url: '/signup/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resumeSignup = <ThrowOnError extends boolean = false>(options: Options<ResumeSignupData, ThrowOnError>): RequestResult<ResumeSignupResponses, ResumeSignupErrors, ThrowOnError> => (options.client ?? client).get<ResumeSignupResponses, ResumeSignupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/signup/session',
    ...options
});

export const findSponsors = <ThrowOnError extends boolean = false>(options?: Options<FindSponsorsData, ThrowOnError>): RequestResult<FindSponsorsResponses, FindSponsorsErrors, ThrowOnError> => (options?.client ?? client).get<FindSponsorsResponses, FindSponsorsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sponsors',
    ...options
});

export const createSponsor = <ThrowOnError extends boolean = false>(options: Options<CreateSponsorData, ThrowOnError>): RequestResult<CreateSponsorResponses, CreateSponsorErrors, ThrowOnError> => (options.client ?? client).post<CreateSponsorResponses, CreateSponsorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sponsors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSponsorById = <ThrowOnError extends boolean = false>(options: Options<DeleteSponsorByIdData, ThrowOnError>): RequestResult<DeleteSponsorByIdResponses, DeleteSponsorByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSponsorByIdResponses, DeleteSponsorByIdErrors, ThrowOnError>({ url: '/sponsors/{id}', ...options });

export const findSponsorById = <ThrowOnError extends boolean = false>(options: Options<FindSponsorByIdData, ThrowOnError>): RequestResult<FindSponsorByIdResponses, FindSponsorByIdErrors, ThrowOnError> => (options.client ?? client).get<FindSponsorByIdResponses, FindSponsorByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sponsors/{id}',
    ...options
});

export const updateSponsor = <ThrowOnError extends boolean = false>(options: Options<UpdateSponsorData, ThrowOnError>): RequestResult<UpdateSponsorResponses, UpdateSponsorErrors, ThrowOnError> => (options.client ?? client).put<UpdateSponsorResponses, UpdateSponsorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sponsors/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const associationStatistics = <ThrowOnError extends boolean = false>(options?: Options<AssociationStatisticsData, ThrowOnError>): RequestResult<AssociationStatisticsResponses, AssociationStatisticsErrors, ThrowOnError> => (options?.client ?? client).get<AssociationStatisticsResponses, AssociationStatisticsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/statistics/association',
    ...options
});

export const createTelemetry = <ThrowOnError extends boolean = false>(options: Options<CreateTelemetryData, ThrowOnError>): RequestResult<CreateTelemetryResponses, CreateTelemetryErrors, ThrowOnError> => (options.client ?? client).post<CreateTelemetryResponses, CreateTelemetryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/telemetry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findTelemetryById = <ThrowOnError extends boolean = false>(options: Options<FindTelemetryByIdData, ThrowOnError>): RequestResult<FindTelemetryByIdResponses, FindTelemetryByIdErrors, ThrowOnError> => (options.client ?? client).get<FindTelemetryByIdResponses, FindTelemetryByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/telemetry/{id}',
    ...options
});

export const findUsers = <ThrowOnError extends boolean = false>(options?: Options<FindUsersData, ThrowOnError>): RequestResult<FindUsersResponses, FindUsersErrors, ThrowOnError> => (options?.client ?? client).get<FindUsersResponses, FindUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users',
    ...options
});

export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError> => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findDeletedUsers = <ThrowOnError extends boolean = false>(options?: Options<FindDeletedUsersData, ThrowOnError>): RequestResult<FindDeletedUsersResponses, FindDeletedUsersErrors, ThrowOnError> => (options?.client ?? client).get<FindDeletedUsersResponses, FindDeletedUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/deleted',
    ...options
});

export const findOwnContributions = <ThrowOnError extends boolean = false>(options?: Options<FindOwnContributionsData, ThrowOnError>): RequestResult<FindOwnContributionsResponses, FindOwnContributionsErrors, ThrowOnError> => (options?.client ?? client).get<FindOwnContributionsResponses, FindOwnContributionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/contributions',
    ...options
});

export const emailAddress = <ThrowOnError extends boolean = false>(options?: Options<EmailAddressData, ThrowOnError>): RequestResult<EmailAddressResponses, EmailAddressErrors, ThrowOnError> => (options?.client ?? client).get<EmailAddressResponses, EmailAddressErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/email',
    ...options
});

export const requestEmailChange = <ThrowOnError extends boolean = false>(options: Options<RequestEmailChangeData, ThrowOnError>): RequestResult<RequestEmailChangeResponses, RequestEmailChangeErrors, ThrowOnError> => (options.client ?? client).post<RequestEmailChangeResponses, RequestEmailChangeErrors, ThrowOnError>({
    url: '/users/me/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findOwnFirstContribution = <ThrowOnError extends boolean = false>(options?: Options<FindOwnFirstContributionData, ThrowOnError>): RequestResult<FindOwnFirstContributionResponses, FindOwnFirstContributionErrors, ThrowOnError> => (options?.client ?? client).get<FindOwnFirstContributionResponses, FindOwnFirstContributionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/first-contribution',
    ...options
});

export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: '/users/me/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const mySecurityEvents = <ThrowOnError extends boolean = false>(options?: Options<MySecurityEventsData, ThrowOnError>): RequestResult<MySecurityEventsResponses, MySecurityEventsErrors, ThrowOnError> => (options?.client ?? client).get<MySecurityEventsResponses, MySecurityEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/security-events',
    ...options
});

export const signOutEverywhere = <ThrowOnError extends boolean = false>(options?: Options<SignOutEverywhereData, ThrowOnError>): RequestResult<SignOutEverywhereResponses, SignOutEverywhereErrors, ThrowOnError> => (options?.client ?? client).delete<SignOutEverywhereResponses, SignOutEverywhereErrors, ThrowOnError>({ url: '/users/me/sign-ins', ...options });

export const signIns = <ThrowOnError extends boolean = false>(options?: Options<SignInsData, ThrowOnError>): RequestResult<SignInsResponses, SignInsErrors, ThrowOnError> => (options?.client ?? client).get<SignInsResponses, SignInsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/sign-ins',
    ...options
});

export const signOutElsewhere = <ThrowOnError extends boolean = false>(options?: Options<SignOutElsewhereData, ThrowOnError>): RequestResult<SignOutElsewhereResponses, SignOutElsewhereErrors, ThrowOnError> => (options?.client ?? client).delete<SignOutElsewhereResponses, SignOutElsewhereErrors, ThrowOnError>({ url: '/users/me/sign-ins/others', ...options });

export const endSignIn = <ThrowOnError extends boolean = false>(options: Options<EndSignInData, ThrowOnError>): RequestResult<EndSignInResponses, EndSignInErrors, ThrowOnError> => (options.client ?? client).delete<EndSignInResponses, EndSignInErrors, ThrowOnError>({ url: '/users/me/sign-ins/{signInId}', ...options });

export const forgetTrustedBrowsers = <ThrowOnError extends boolean = false>(options?: Options<ForgetTrustedBrowsersData, ThrowOnError>): RequestResult<ForgetTrustedBrowsersResponses, ForgetTrustedBrowsersErrors, ThrowOnError> => (options?.client ?? client).delete<ForgetTrustedBrowsersResponses, ForgetTrustedBrowsersErrors, ThrowOnError>({ url: '/users/me/trusted-browsers', ...options });

export const trustedBrowsers = <ThrowOnError extends boolean = false>(options?: Options<TrustedBrowsersData, ThrowOnError>): RequestResult<TrustedBrowsersResponses, TrustedBrowsersErrors, ThrowOnError> => (options?.client ?? client).get<TrustedBrowsersResponses, TrustedBrowsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/trusted-browsers',
    ...options
});

export const forgetTrustedBrowser = <ThrowOnError extends boolean = false>(options: Options<ForgetTrustedBrowserData, ThrowOnError>): RequestResult<ForgetTrustedBrowserResponses, ForgetTrustedBrowserErrors, ThrowOnError> => (options.client ?? client).delete<ForgetTrustedBrowserResponses, ForgetTrustedBrowserErrors, ThrowOnError>({ url: '/users/me/trusted-browsers/{id}', ...options });

export const turnOffTwoFactor = <ThrowOnError extends boolean = false>(options?: Options<TurnOffTwoFactorData, ThrowOnError>): RequestResult<TurnOffTwoFactorResponses, TurnOffTwoFactorErrors, ThrowOnError> => (options?.client ?? client).delete<TurnOffTwoFactorResponses, TurnOffTwoFactorErrors, ThrowOnError>({ url: '/users/me/two-factor', ...options });

export const twoFactorStanding = <ThrowOnError extends boolean = false>(options?: Options<TwoFactorStandingData, ThrowOnError>): RequestResult<TwoFactorStandingResponses, TwoFactorStandingErrors, ThrowOnError> => (options?.client ?? client).get<TwoFactorStandingResponses, TwoFactorStandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/two-factor',
    ...options
});

export const regenerateBackupCodes = <ThrowOnError extends boolean = false>(options?: Options<RegenerateBackupCodesData, ThrowOnError>): RequestResult<RegenerateBackupCodesResponses, RegenerateBackupCodesErrors, ThrowOnError> => (options?.client ?? client).post<RegenerateBackupCodesResponses, RegenerateBackupCodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/two-factor/backup-codes',
    ...options
});

export const confirmTwoFactor = <ThrowOnError extends boolean = false>(options: Options<ConfirmTwoFactorData, ThrowOnError>): RequestResult<ConfirmTwoFactorResponses, ConfirmTwoFactorErrors, ThrowOnError> => (options.client ?? client).post<ConfirmTwoFactorResponses, ConfirmTwoFactorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/two-factor/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const answerTwoFactorOffer = <ThrowOnError extends boolean = false>(options?: Options<AnswerTwoFactorOfferData, ThrowOnError>): RequestResult<AnswerTwoFactorOfferResponses, AnswerTwoFactorOfferErrors, ThrowOnError> => (options?.client ?? client).post<AnswerTwoFactorOfferResponses, AnswerTwoFactorOfferErrors, ThrowOnError>({ url: '/users/me/two-factor/offer', ...options });

export const twoFactorSaved = <ThrowOnError extends boolean = false>(options?: Options<TwoFactorSavedData, ThrowOnError>): RequestResult<TwoFactorSavedResponses, TwoFactorSavedErrors, ThrowOnError> => (options?.client ?? client).post<TwoFactorSavedResponses, TwoFactorSavedErrors, ThrowOnError>({ url: '/users/me/two-factor/saved', ...options });

export const setUpTwoFactor = <ThrowOnError extends boolean = false>(options: Options<SetUpTwoFactorData, ThrowOnError>): RequestResult<SetUpTwoFactorResponses, SetUpTwoFactorErrors, ThrowOnError> => (options.client ?? client).post<SetUpTwoFactorResponses, SetUpTwoFactorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/me/two-factor/setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteUserById = <ThrowOnError extends boolean = false>(options: Options<DeleteUserByIdData, ThrowOnError>): RequestResult<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError>({ url: '/users/{userId}', ...options });

export const findUserById = <ThrowOnError extends boolean = false>(options: Options<FindUserByIdData, ThrowOnError>): RequestResult<FindUserByIdResponses, FindUserByIdErrors, ThrowOnError> => (options.client ?? client).get<FindUserByIdResponses, FindUserByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}',
    ...options
});

export const accountStanding = <ThrowOnError extends boolean = false>(options: Options<AccountStandingData, ThrowOnError>): RequestResult<AccountStandingResponses, AccountStandingErrors, ThrowOnError> => (options.client ?? client).get<AccountStandingResponses, AccountStandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/account-security',
    ...options
});

export const findGameAccounts = <ThrowOnError extends boolean = false>(options: Options<FindGameAccountsData, ThrowOnError>): RequestResult<FindGameAccountsResponses, FindGameAccountsErrors, ThrowOnError> => (options.client ?? client).get<FindGameAccountsResponses, FindGameAccountsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/game-accounts',
    ...options
});

export const clearGameAccount = <ThrowOnError extends boolean = false>(options: Options<ClearGameAccountData, ThrowOnError>): RequestResult<ClearGameAccountResponses, ClearGameAccountErrors, ThrowOnError> => (options.client ?? client).delete<ClearGameAccountResponses, ClearGameAccountErrors, ThrowOnError>({ url: '/users/{userId}/game-accounts/{game}', ...options });

export const setGameAccount = <ThrowOnError extends boolean = false>(options: Options<SetGameAccountData, ThrowOnError>): RequestResult<SetGameAccountResponses, SetGameAccountErrors, ThrowOnError> => (options.client ?? client).put<SetGameAccountResponses, SetGameAccountErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/game-accounts/{game}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findMemberProfileByUserId = <ThrowOnError extends boolean = false>(options: Options<FindMemberProfileByUserIdData, ThrowOnError>): RequestResult<FindMemberProfileByUserIdResponses, FindMemberProfileByUserIdErrors, ThrowOnError> => (options.client ?? client).get<FindMemberProfileByUserIdResponses, FindMemberProfileByUserIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/memberProfiles',
    ...options
});

export const updateMemberProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberProfileData, ThrowOnError>): RequestResult<UpdateMemberProfileResponses, UpdateMemberProfileErrors, ThrowOnError> => (options.client ?? client).put<UpdateMemberProfileResponses, UpdateMemberProfileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/memberProfiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const boardCreateMembership = <ThrowOnError extends boolean = false>(options: Options<BoardCreateMembershipData, ThrowOnError>): RequestResult<BoardCreateMembershipResponses, BoardCreateMembershipErrors, ThrowOnError> => (options.client ?? client).post<BoardCreateMembershipResponses, BoardCreateMembershipErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/memberships',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findDeletedMemberships = <ThrowOnError extends boolean = false>(options: Options<FindDeletedMembershipsData, ThrowOnError>): RequestResult<FindDeletedMembershipsResponses, FindDeletedMembershipsErrors, ThrowOnError> => (options.client ?? client).get<FindDeletedMembershipsResponses, FindDeletedMembershipsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/memberships/deleted',
    ...options
});

export const setNameOnRosters = <ThrowOnError extends boolean = false>(options: Options<SetNameOnRostersData, ThrowOnError>): RequestResult<SetNameOnRostersResponses, SetNameOnRostersErrors, ThrowOnError> => (options.client ?? client).put<SetNameOnRostersResponses, SetNameOnRostersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/name-on-rosters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const restoreDeletedUserById = <ThrowOnError extends boolean = false>(options: Options<RestoreDeletedUserByIdData, ThrowOnError>): RequestResult<RestoreDeletedUserByIdResponses, RestoreDeletedUserByIdErrors, ThrowOnError> => (options.client ?? client).put<RestoreDeletedUserByIdResponses, RestoreDeletedUserByIdErrors, ThrowOnError>({ url: '/users/{userId}/restore', ...options });

export const findUserRoleChanges = <ThrowOnError extends boolean = false>(options: Options<FindUserRoleChangesData, ThrowOnError>): RequestResult<FindUserRoleChangesResponses, FindUserRoleChangesErrors, ThrowOnError> => (options.client ?? client).get<FindUserRoleChangesResponses, FindUserRoleChangesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/role-changes',
    ...options
});

export const findUserRoles = <ThrowOnError extends boolean = false>(options: Options<FindUserRolesData, ThrowOnError>): RequestResult<FindUserRolesResponses, FindUserRolesErrors, ThrowOnError> => (options.client ?? client).get<FindUserRolesResponses, FindUserRolesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/roles',
    ...options
});

export const setUserRoles = <ThrowOnError extends boolean = false>(options: Options<SetUserRolesData, ThrowOnError>): RequestResult<SetUserRolesResponses, SetUserRolesErrors, ThrowOnError> => (options.client ?? client).put<SetUserRolesResponses, SetUserRolesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const findPlayedRosters = <ThrowOnError extends boolean = false>(options: Options<FindPlayedRostersData, ThrowOnError>): RequestResult<FindPlayedRostersResponses, FindPlayedRostersErrors, ThrowOnError> => (options.client ?? client).get<FindPlayedRostersResponses, FindPlayedRostersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/rosters',
    ...options
});

export const securityEvents = <ThrowOnError extends boolean = false>(options: Options<SecurityEventsData, ThrowOnError>): RequestResult<SecurityEventsResponses, SecurityEventsErrors, ThrowOnError> => (options.client ?? client).get<SecurityEventsResponses, SecurityEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/users/{userId}/security-events',
    ...options
});

export const resetTwoFactor = <ThrowOnError extends boolean = false>(options: Options<ResetTwoFactorData, ThrowOnError>): RequestResult<ResetTwoFactorResponses, ResetTwoFactorErrors, ThrowOnError> => (options.client ?? client).post<ResetTwoFactorResponses, ResetTwoFactorErrors, ThrowOnError>({
    url: '/users/{userId}/two-factor/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resendReenrolmentLink = <ThrowOnError extends boolean = false>(options: Options<ResendReenrolmentLinkData, ThrowOnError>): RequestResult<ResendReenrolmentLinkResponses, ResendReenrolmentLinkErrors, ThrowOnError> => (options.client ?? client).post<ResendReenrolmentLinkResponses, ResendReenrolmentLinkErrors, ThrowOnError>({ url: '/users/{userId}/two-factor/reset/resend', ...options });

export const unlock = <ThrowOnError extends boolean = false>(options: Options<UnlockData, ThrowOnError>): RequestResult<UnlockResponses, UnlockErrors, ThrowOnError> => (options.client ?? client).post<UnlockResponses, UnlockErrors, ThrowOnError>({
    url: '/users/{userId}/unlock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const version = <ThrowOnError extends boolean = false>(options?: Options<VersionData, ThrowOnError>): RequestResult<VersionResponses, VersionErrors, ThrowOnError> => (options?.client ?? client).get<VersionResponses, VersionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/version',
    ...options
});
